<template>
  <div class="c-header-component"
       :class="{
          'active' : show,
          'mouse' : type === 'mouse'
        }"
       @mousemove="handleMouse"
       @mouseleave="handleMouse">
    <div class="c-header-left">
      <div class="weather" v-if="type === 'mouse' && weather.low">
        <span>{{ weather.low }} ~ {{ weather.high }}℃</span>
        <span>{{ weather.type }}</span>
        <span>空气质量：{{ weather.quality }}</span>
      </div>
    </div>
    <ul class="c-header-right">
      <li class="date">
        <span>{{new Date() | time('yyyy-MM-dd')}}</span>
        <span>{{ time }}</span>
        <span>农历{{new Date() | lunarCalendar}}</span>
      </li>
      <!--<li class="onMsg">-->
        <!--<i class="iconfont">&#xe637;</i>-->
      <!--</li>-->
      <li class="onSwitch"
          v-if="type !== 'normal'">
        <i class="iconfont" @click="handleSwitch">&#xe636;</i>
      </li>
      <li class="handleAdjust"
          v-if="type !== 'normal'">
        <i class="iconfont" @click="handleAdjust">&#xe634;</i>
      </li>
      <li class="onSetting">
        <el-popover
            v-model="popover"
            placement="bottom"
            popper-class="setting-popover"
            trigger="manual">
          <p class="setting-col" @click="settingPersonal"><i class="iconfont">&#xe645;</i>个人信息</p>
          <p class="setting-col" @click="handleLogOut"><i class="iconfont">&#xe643;</i>退出登录</p>
          <i class="iconfont" slot="reference" @click="popover = !popover">&#xe635;</i>
        </el-popover>
        <personal ref="personal" @hide="onPersonalHide"></personal>
      </li>
    </ul>
  </div>
</template>
<script>
  import personal from './setting/personal';
  export default {
    name: 'c-header-component',
    components: {
      personal
    },
    props: {
      type: {
        type: String,
        default: 'mouse'
      }
    },
    data(){
      return {
        time: null,

        popover: false,
        personalShow: false,
        mouseEnter: false,

        hideTimer: null,

        weather: {}
      }
    },
    computed: {
      show(){
        if (this.type === 'normal' || this.popover || this.personalShow) {
          return true;
        }
        return this.mouseEnter
      },
    },
    methods: {
      handleMouse(e){
        if(this.type === 'normal') return false;
        clearTimeout(this.hideTimer);
        switch (e.type) {
          case 'mousemove': {
            this.mouseEnter = true;
            break;
          }
          case 'mouseleave': {
            this.hideTimer = setTimeout(() => this.mouseEnter = false, 2e3)
            break;
          }
        }
      },
      /**
       * 调整布局
       */
      handleAdjust(){
        if(this.$store.getters.isDraggable) {
          this.$store.dispatch('setLayouts').then(() => {
            this.$store.commit('SET_IS_DRAGGABLE', false)
          })
        }
        else {
          this.$store.commit('SET_IS_DRAGGABLE', true)
        }
      },
      handleSwitch(){
        this.$router.push({ name: 'switchCommunity' })
      },
      handleLogOut(){
        this.$store.dispatch('updateUserInfo', null);
        this.$router.push({name: 'login'})
      },
      settingPersonal(){
        this.popover = false;
        this.personalShow = true;
        this.$refs.personal.$emit('show')
      },
      onPersonalHide(){
        this.personalShow = false;
      },
      getWeather(){
        this.$http('busWeather', {
          city: this.$store.state.user.currentCommunity.city,
        }).then( res => {
          if(!res.errorCode) {
            this.weather = res.data;
          }
        })
      },
      updateTime(){
        this.time = this.$options.filters.time(new Date(), 'HH:mm');
      }
    },
    mounted(){
      if(this.type === 'mouse' && this.$store.state.user.currentCommunity.city) {
        this.getWeather();
        this.$store.commit('SET_TASK', {name: 'hour', key: 'weather', task: this.getWeather});
      }
      this.updateTime()
      this.$store.commit('SET_TASK', {name: 'oneMinutes', key: 'updateTime', task: this.updateTime});
    },
    destroyed(){
      this.$store.commit('DELETE_TASK', {name: 'hour', key: 'weather'})
      this.$store.commit('DELETE_TASK', {name: 'oneMinutes', key: 'updateTime'})
    }
  }
</script>
<style lang="scss" scoped>
  @import "~@/assets/style/mixins";

  .c-header-component {
    width: 100%;
    height: 84px;
    background: url("~@/assets/style/theme/default/headerBg.png") no-repeat 0 0;
    background-size: cover;
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
    color: #2C76FE;
    transition: all .25s;
    &.mouse {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2000;
      transform: translateY(-66px);
      opacity: 0;
    }
    &.active {
      opacity: 1;
      transform: translateY(0);
    }
  }

  ul.c-header-right {
    height: 70px;
    display: flex;
    li {
      height: 70px;
      line-height: 70px;
      margin-left: 20px;
      i {
        font-size: 26px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .onSetting {
      position: relative;
    }
    .date {
      span {
        margin-left: 20px;
      }
    }

  }

  .setting-col {
    padding: 0 30px;
    margin: 25px 0;
    @include hoverPointer;
    i {
      margin-right: 10px;
    }
  }

  .c-header-left {
    height: 62px;
    font-size: 20px;
    color: #2C76FE;
    display: flex;
    align-items: center;
    .weather {
      span { padding-right: 20px }
    }
  }


</style>
<style lang="scss">
  .setting-popover {
    background-color: #006CFD;
    border-color: #006CFD;
    color: #fff;
    padding: 0;
    min-width: 180px;
    .popper__arrow {
      border-bottom-color: #006CFD !important;
      &::after {
        border-bottom-color: #006CFD !important;
      }
    }
  }
</style>